function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "search icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dacbh89tza"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 74",
    style: {
      fill: "#707070"
    },
    d: "M0 0h18v18H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59",
    style: {
      clipPath: "url(#dacbh89tza)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42",
    d: "M11.285 10.242a6.323 6.323 0 1 0-1.043 1.043l5.493 5.493 1.043-1.043zm-1.126-.083a5.425 5.425 0 1 1-7.672-7.672 5.425 5.425 0 1 1 7.672 7.672",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 43",
    d: "m899.247 898.2-.658-.657-1.043 1.043.657.657a.628.628 0 0 0 .889 0l.154-.154a.628.628 0 0 0 0-.889",
    transform: "translate(-881.431 -881.432)",
    style: {
      fill: "#707070"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7b9660907a5f6a5334e4aec980063823.svg";
export { ForwardRef as ReactComponent };